export var CalendarRecurrenceFrequency;
(function (CalendarRecurrenceFrequency) {
    CalendarRecurrenceFrequency[CalendarRecurrenceFrequency["Weekly"] = 1] = "Weekly";
    CalendarRecurrenceFrequency[CalendarRecurrenceFrequency["Monthly"] = 2] = "Monthly";
    CalendarRecurrenceFrequency[CalendarRecurrenceFrequency["Quarterly"] = 3] = "Quarterly";
    CalendarRecurrenceFrequency[CalendarRecurrenceFrequency["HalfYearly"] = 4] = "HalfYearly";
})(CalendarRecurrenceFrequency || (CalendarRecurrenceFrequency = {}));
//# sourceMappingURL=calendarRecurrenceFrequency.enum.js.map